/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it

/* eslint-disable import/prefer-default-export */
import 'normalize.css';
import '~/stylesheets/global.scss';

import { sendPageView } from '~/utils/analytics';

export const onRouteUpdate = async ({ location }) => {
  if (process.env.GATSBY_PRODUCTION) {
    await sendPageView(location.pathname);
  }
};
